import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    padding: 100,
    mobile: {
      desktop: {
        padding: 100,
      },
      smartphone: {
        padding: 15,
      },
    },
  },
  HEADLINE: {
    fontFamily: theme.fontFamily,
    fontSize: "32pt",
    // fontWeight: "bold" as "bold",
    textAlign: "center",
    padding: 20,
    mobile: {
      desktop: {
        fontSize: "32pt",
      },
      smartphone: {
        fontSize: "22pt",
      },
    },
  },
  TEXT: {
    fontFamily: theme.fontFamily,
    fontSize: "13pt",
    textAlign: "center",
    lineHeight: "18pt",
    padding: 40,
    mobile: {
      desktop: {
        padding: 40,
      },
      smartphone: {
        padding: 20,
      },
    },
  },
};
